// extracted by mini-css-extract-plugin
export default {"root":"CalendarNavigation-module_root_d8124d","calendar":"CalendarNavigation-module_calendar_ed1c52","stickyCalendar":"CalendarNavigation-module_stickyCalendar_b0abb4"};